<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input class="filter-item" v-model="listQuery.querymodel.keyword" placeholder="小票名称" style="width: 200px"
        @keyup.enter.native="getList()" />
      <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    </div>
    <el-table class="app-table" :data="list" border fit highlight-current-row stripe style="width: 100%"
      :height="getViewHeight()" :header-cell-style="{ background: '#F3F4F7', color: '#555' }"
      :row-style="{ height: '10px' }" :cell-style="{ padding: '7px 0' }">
      <el-table-column :key="i" v-for="(col, i) in columns" :label="col.label" :align="col.align" :prop="col.value"
        :type="col.type" :width="col.width">
      </el-table-column>
      <el-table-column label="操作" align="center" :min-width="190">
        <template slot-scope="{ row }">
          <el-button type="primary" size="mini" icon="el-icon-edit" v-if="authedit" @click="edit(row)">
            编辑
          </el-button>
          <el-button v-if="authdelete" icon="el-icon-delete" size="mini" type="danger" @click="deleted(row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageIndex" :limit.sync="listQuery.pageSize"
      @pagination="getList" />
    <addticket v-if="dialogshow" :dialogshow="dialogshow" :isedit="isedit" :editform="editform"
      @savecomplete="savecomplete" @cancelcomplete="cancelcomplete"></addticket>
  </div>
</template>
<script>
import { query, deleted } from "@/api/ticket";
import waves from "@/directive/waves"; // waves directive
import { getButtonList } from "../../promissionRouter";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import Toolbar from "../../components/Toolbar";
import addticket from "./components/addticket.vue";
export default {
  components: { Pagination, Toolbar, addticket },
  directives: { waves },
  data() {
    return {
      dialogshow: false,
      isedit: false,
      buttonList: [],
      isedit: false,
      authedit: false,
      authdelete: false,
      editform: {},
      downloadLoading: false,
      list: null,
      pageIndex: 1,
      total: 0,
      columns: [
        {
          label: "序号",
          value: "index",
          align: "center",
          type: "index",
          width: 100,
        },
        { label: "模板名称", value: "TicketName", align: "center", type: "" },
        { label: "小票标题", value: "TicketTitle", align: "center" },
        { label: "创建时间", value: "CreateTime", align: "center" },
      ],
      listQuery: {
        pageIndex: 1,
        pageSize: 15,
        orderColumn: "",
        orderbyasc: false,
        querymodel: {
          keyword: "",
        },
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    callFunction(item) {
      this[item.BtnCode].apply(this, item);
    },
    create() {
      this.isedit = false;
      this.dialogshow = true;
    },
    edit(row) {
      this.editform = row;
      this.isedit = true;
      this.dialogshow = true;
    },
    savecomplete(item) {
      this.dialogshow = false;
      this.getList();
    },
    cancelcomplete() {
      this.dialogshow = false;
    },
    deleted(row) {
      this.$confirm("确定删除吗?", "提示", {
        type: "warning",
      }).then(() => {
        deleted({ id: row.Id }).then((res) => {
          this.$message({
            message: "删除成功！",
            type: "success",
          });
          this.getList();
        });
      });
    },
    getList(item) {
      if (item != null && item != undefined) {
        this.listQuery.pageIndex = item.page;
        this.listQuery.pageSize = item.limit;
      } else {
        this.listQuery.pageIndex = 1;
      }
      query(this.listQuery).then((res) => {
        this.list = res.data;
        this.total = res.dataCount;
      });
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.buttonList.forEach((item) => {
      if (item.BtnCode === "delete") {
        this.authdelete = true;
      }
      if (item.BtnCode === "edit") {
        this.authedit = true;
      }
    });
  },
};
</script>
